import type React from "react";

type Cta = {
  label: string;
  href: string;
  isExternal?: boolean;
};

type CallToActionBannerProps = {
  title: string;
  body: string;
  primaryCta: Cta;
  secondaryCta?: Cta;
};

const CallToActionBanner: React.FC<CallToActionBannerProps> = ({
  title,
  body,
  primaryCta,
  secondaryCta,
}) => {
  return (
    <section className="bg-primary-900 py-16 text-white">
      <div className="container flex flex-col gap-6 rounded-3xl border border-primary-100/20 bg-gradient-to-r from-primary-900 to-primary-800 p-10 shadow-xl md:flex-row md:items-center md:justify-between">
        <div className="max-w-2xl">
          <h2 className="text-3xl font-semibold">{title}</h2>
          <p className="mt-4 text-base text-primary-100/90">{body}</p>
        </div>
        <div className="flex flex-col gap-3 md:flex-row md:items-center">
          <a
            href={primaryCta.href}
            className="btn-primary"
            target={primaryCta.isExternal ? "_blank" : undefined}
            rel={primaryCta.isExternal ? "noreferrer" : undefined}
          >
            {primaryCta.isExternal ? (
              <span>
                {primaryCta.label}
                <span className="sr-only"> (opens in a new tab)</span>
              </span>
            ) : (
              primaryCta.label
            )}
          </a>
          {secondaryCta ? (
            <a
              href={secondaryCta.href}
              target={secondaryCta.isExternal ? "_blank" : undefined}
              rel={secondaryCta.isExternal ? "noreferrer" : undefined}
              className="btn-outline border-white text-white hover:border-white/80 hover:bg-white/10 hover:text-white"
            >
              {secondaryCta.label}
            </a>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default CallToActionBanner;
